// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6b21e727","103":"62c64c6c","435":"973ef7e9","453":"cf82760c"}[chunkId] + ".chunk.js";
};